/* Thalira signup bot guard - honeypot + instant-submit trap. Fail-safe: if this errors, forms work normally. */
(function () {
  function guard(form) {
    if (form.__nbg) return; form.__nbg = true;
    var hp = form.querySelector('input[name="hp_url"]');
    if (!hp) {
      hp = document.createElement('input');
      hp.type = 'text'; hp.name = 'hp_url'; hp.tabIndex = -1;
      hp.setAttribute('autocomplete', 'off'); hp.setAttribute('aria-hidden', 'true');
      hp.style.cssText = 'position:absolute!important;left:-9999px!important;top:auto!important;width:1px;height:1px;opacity:0;pointer-events:none;';
      form.appendChild(hp);
    }
    var t0 = Date.now();
    form.addEventListener('submit', function (e) {
      if ((hp.value || '') !== '' || (Date.now() - t0) < 1500) {
        e.preventDefault(); e.stopImmediatePropagation();
        try { console.warn('Signup blocked (bot heuristic).'); } catch (x) {}
        return false;
      }
    }, true);
  }
  function init() {
    try { document.querySelectorAll('form.newsletter-form, form.article-cta__form').forEach(guard); } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
